import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService, tryCatch } from '@laasy/common-layout';
import { firstValueFrom } from 'rxjs';
import { HomeService } from 'src/app/shared/services/home.service';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { AppConstants } from 'src/app/shared/utilities/constants';

@Component({
  selector: 'app-common-welcome',
  templateUrl: './common-welcome.component.html',
  styleUrls: ['./common-welcome.component.scss']
})
export class CommonWelcomeComponent implements OnInit {

  @Input() continueText = 'Get started';
  @Output() next = new EventEmitter();
  tenantName = 'Laasy';
  screenWidth !: number;
  showMainAttractionsData: any = [];
  mainAttractionsData = AppConstants.gettingStartedMainAttractionContent;
  pageQuote = AppConstants.signUpPageQuote;
  icons: any = {};

  constructor(private tenantService: TenantService, private commonService: CommonService, private homeService: HomeService) {}

  ngOnInit(): void {
    this.tenantService.getTenantAppConfig().subscribe((data: any) => {
      this.pageQuote = data.signupWelcomeSubtitle ?? AppConstants.signUpPageQuote;
      this.tenantName = data.name ?? this.tenantName;
    });
    this.homeService.getCustomization().subscribe(async (data: any) => {
      this.showMainAttractionsData = data.signupPage?.attractions ?? this.mainAttractionsData;
      this.pageQuote = data.signupPage?.pageQuote ?? AppConstants.signUpPageQuote;
      this.showMainAttractionsData.forEach(async (item: any) => {
        if(!item.iconLink) return
        const icon = await tryCatch(firstValueFrom(this.commonService.getSvgCode(item.iconLink)));
        if(icon.error){
          return;
        }
        this.icons[item.link] = icon.data;
      });

    });

    AppConstants.gettingStartedMainAttractionContent.forEach(async (item: any) => {
      const url = `/assets/icons/welcome-page/${item.link}.svg#${item.link}`;
      const icon = await tryCatch(firstValueFrom(this.commonService.getSvgCode(url)));
      if(icon.error){
        return;
      }
      this.icons[item.link] = icon.data;
    });
  }
}
